<template>
    <section :id="id" class="ui-pop" :class="active">
        <div class="overlay"/>
        <div class="box">
            <div class="header">
                <div>
                    <h3>{{title}}</h3>
                    <p>{{text}}</p>
                </div>
                <div>
                    <button type="button" @click="close">
                        <i class="fal fa-times"/>
                    </button>
                </div>
            </div>
            <div class="body">
                <slot/>
            </div>
            <div class="footer">
                <slot name="footer"/>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        name: 'ui-popup',
        props:{
           title: {
               type: String,
               required: true,
           },
           text: {
               type: String,
               required: true,
           },
           name: {
               type: String,
               required: true,
           }
        },
        data() {
            return {
                status: false,
            }
        },

        computed: {
            active(){
                return this.status ? 'active' : ''
            },
            id(){
                return 'ui-popup-' + this._uid
            }
        },
        
        watch: {
            status(newValue){
                this.status = newValue
            },
        },

        mounted() {
            this.$root.$on('popup-close-'+this.name, () => {
                this.close()
            })
            this.$root.$on('popup-open-'+this.name, () => {
                this.open()
            })
            this.$root.$on('popup-toggle-'+this.name, () => {
                this.toggle()
            })
        },

        beforeDestroy() {
            this.$root.$off('popup-close-'+this.name)
            this.$root.$off('popup-open-'+this.name)
            this.$root.$off('popup-toggle-'+this.name)
        },

        methods: {
            close(){
                this.status = false
            },
            open(){
                this.status = true
            },
            toggle(){
                this.status = !this.status
            }
        }
    };

</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>